export class SurveyQuestionResponseModel {
    id: string;
    survey_questionId: string;
    thumbs_up_down: boolean;
    feedback_text: string;
    dismissed: boolean;
    group_id: string;
    user_id: string;
    property_id: string;
    market_id: string;
    implementation_id: string;
    survey_meta: Array<SurveyMetaModel>;
}
export class SurveyMetaModel {
  id: string;
  meta_type: string;
}
export class SurveyQuestionModel
{
    public id:string;
    public name:string;
    public date_created:Date;
    public date_updated:Date;
    public enabled:boolean;
    public question_text:string;
    public modification_notes:string;

}

export class SurveyQuestionDialogModel
{
  public survey_question_id: string;
    public question_text:string;
    public survey_meta: Array<SurveyMetaModel>;
}
